export default __webpack_public_path__ + "static/media/EM0333.34I-41694_-24998_0.9fcab503.jpg";